<template>
  <div class="flex flex-col lg:flex-row gap-4">
    <!--eslint-disable vue/no-v-html-->
    <div
      v-if="section.media"
      class="order-1 lg:w-1/3"
      :class="!isEven && 'lg:order-2'"
    >
      <ThreeSixtyImage
        v-if="section.media.threeSixtyImage"
        :three-sixty-image="section.media.threeSixtyImage"
      />
      <VideoIframe
        if="section.media.videoUrl"
        class="aspect-video rounded-xl overflow-hidden"
        extra-classes="cmplazyload"
        :data-cmp-src="section.media.videoUrl"
        video-url="about:blank"
        :data-cmp-vendor="CONSENT_MANAGER_VENDOR.YOUTUBE"
        :data-cmp-purpose="CONSENT_MANAGER_PURPOSE.ESSENTIAL"
      />
    </div>
    <div
      class="order-1"
      :class="section.media && 'lg:w-2/3'"
    >
      <h3
        v-if="section.title"
        class="mb-2 text-base lg:text-xl"
      >
        {{ section.title }}
      </h3>
      <div
        v-for="(text, textIndex) in section.paragraphs"
        :key="textIndex"
        class="leading-6"
        v-html="text"
      />
    </div>
  </div>
</template>

<script lang="ts">

import type { ProductDescriptionSection } from '~~/types/product/ProductDescription';
import { CONSENT_MANAGER_VENDOR, CONSENT_MANAGER_PURPOSE } from '~~/constants/consentManager';

export default defineComponent({
  name: 'ProductDescriptionSection',

  props: {
    section: {
      type: Object as PropType<ProductDescriptionSection>,
      required: true,
    },
    sectionIndex: {
      type: Number,
      required: true,
    },
  },
  setup(props) {

    const isEven = computed(() => props.sectionIndex % 2);

    return {
      isEven,
      CONSENT_MANAGER_VENDOR,
      CONSENT_MANAGER_PURPOSE,
    };
  
  },
});

</script>
